import { render } from "./impressum.vue?vue&type=template&id=63ae8a6f"
import script from "./impressum.vue?vue&type=script&lang=js"
export * from "./impressum.vue?vue&type=script&lang=js"

import "./impressum.vue?vue&type=style&index=0&id=63ae8a6f&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__